/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// import deleteicon from '../../images/Delete.png';

import Urls from '../../utils/urls';

interface invitationType {
  invitation: string;
  email:string,
  date:string,
  reference:string,
  status:string

}
interface Data {
  entires: invitationType[],
  type: string
}

const InvitationTable = ({ entires, type }: Data) => (
    <div>
      {entires.length === 0 && (
        <div style={{ color: '#ABB2B9', textAlign: 'center', fontSize: '20px' }}>
          No Data
        </div>
      )}
      <div id="succ" className="alert alert-success mt-3 mb-5" style={{ display: 'none' }} role="alert">Key Copied</div>
      {entires.length > 0 && (
        <table className="table mt-4">
          <thead className="head-bg">
            <tr>
              <th className="col-1">From</th>
              <th className="col-1 ">Invitation for</th>
              <th className="col-1">Reference Name</th>
              <th className="col-1">Date of Creation</th>
              <th className="col-1">Status</th>
              <th className="col-2">Action</th>
            </tr>
          </thead>
          <tbody>
          {entires.map((d, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={idx.toString()}>
                <td style={{ paddingTop: '.8rem' }}>{d.email}</td>
                <td style={{ paddingTop: '.8rem' }}>{d.invitation}</td>
                <td style={{ paddingTop: '.8rem' }}>{d.reference}</td>
                <td style={{ paddingTop: '.8rem' }}>{d.date}</td>
                <td style={{ paddingTop: '.8rem' }}>
                    {
                    d.status === 'Pending'
                    && <button type="button" disabled className="btn btn-warning">Pending</button>
                    }
                    {
                    d.status === 'Accepted'
                    && <button type="button" disabled className="btn btn-success">Acceped</button>
                    }
                    {
                    d.status === 'Rejected'
                    && <button type="button" disabled className="btn btn-danger">Rejected</button>
                    }
                    {
                    d.status === 'Cancelled'
                    && <button type="button" disabled className="btn btn-secondary">Cancelled</button>
                    }
                </td>
                <td style={{ paddingTop: '.8rem' }}>
                    {
                    type === 'received' && d.status === 'Pending'
                    && (
                      <>
                    <button type="button" className="btn btn-success mx-1">Accept & Deploy</button>
                    <button type="button" className="btn btn-warning">Reject</button>
                      </>
                    )
                    }
                    {
                    type === 'received' && d.status !== 'Pending'
                    && (
                      <a href={Urls.cordaFrontend()} style={{ textDecoration: 'none' }}>
                      <button type="button" className="btn btn-primary mx-1">View</button>
                      </a>
                    )
                    }
                    {/* / */}

                    {
                    type !== 'received' && d.status === 'Pending'
                    && <button type="button" className="btn btn-danger">Cancel</button>
                    }
                    {
                    type !== 'received' && d.status !== 'Pending'
                    && (
                      <a href={Urls.cordaFrontend()} style={{ textDecoration: 'none' }}>
                      <button type="button" className="btn btn-primary mx-1">View</button>
                      </a>
                    )
                    }
                </td>
              </tr>
          ))}
          </tbody>
        </table>
      )}
    </div>
);

export default InvitationTable;
